import React from 'react'
import { LinkIcon } from '../ButtonIcons'

const ChatHomeLink = ({
  icon: Icon = LinkIcon,
  label = 'Download latest files',
  href = '#',
  target = '_blank',
  onClick,
  className = '',
  disabled = false,
  visible = true,
  config,
  ...props
}) => {
  if (!visible) return null;

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  // Helper to check if icon is a string and a link (http/https or data url)
  const isIconUrl = typeof Icon === 'string' && (
    Icon.startsWith('http://') ||
    Icon.startsWith('https://') ||
    Icon.startsWith('data:')
  );

  return (
    <a
      href={disabled ? undefined : href}
      target={target}
      onClick={handleClick}
      className={`
        bubble-home-link
        flex
        items-center
        gap-v3-xs
        p-v3-sm
        no-underline
        transition-all
        duration-200
        text-[var(--element-color)]
        hover:!text-[var(--brand-color)]
        ${disabled ? 'opacity-50 cursor-not-allowed disabled:hover:text-inherit' : 'cursor-pointer'}
        ${className}
      `}
      style={{
        '--brand-color': config?.brand_color || 'var(--v3-purple-primary)',
        '--element-color': config?.element_color || 'var(--v3-black-max)',
        fontFamily: config?.font_name ? `${config.font_name}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : undefined,
        fontSize: config?.font_size ? `${config.font_size}px` : undefined,
      }}
      {...props}
    >
      {Icon && (
        isIconUrl ? (
          <img src={Icon} className="flex-shrink-0" alt="icon" />
        ) : (
          typeof Icon === 'function' ? (
            <Icon className="flex-shrink-0 text-[var(--brand-color)]" />
          ) : null
        )
      )}
      <span className="font-medium">{label}</span>
    </a>
  )
}

export default ChatHomeLink